import { s__ } from '~/locale';
import { getScrollingElement } from '~/lib/utils/panels';
import { scrollToElement, resolveScrollContainer, computeActiveSection } from '~/lib/utils/scroll_utils';
export default {
    name: 'PageNavigationMenu',
    components: {},
    props: {
        title: {
            type: String,
            required: false,
            default: ()=>s__('PageNavigation|On this page')
        },
        items: {
            type: Array,
            required: true,
            validator: (items)=>items.every((item)=>item.id && item.label)
        },
        scrollOffset: {
            type: Number,
            required: false,
            default: -10
        },
        autoUpdateDelay: {
            type: Number,
            required: false,
            default: 1500
        }
    },
    data () {
        return {
            activeSection: null,
            scrollingElement: null,
            scrollRafId: null,
            suppressAutoUpdateUntil: 0
        };
    },
    mounted () {
        this.setInitialActiveSection();
        this.initScrollTracking();
    },
    beforeDestroy () {
        if (this.scrollingElement) {
            this.scrollingElement.removeEventListener('scroll', this.onScroll);
        }
        if (this.scrollRafId) {
            cancelAnimationFrame(this.scrollRafId);
            this.scrollRafId = null;
        }
    },
    methods: {
        getCurrentTimestamp () {
            return typeof performance !== 'undefined' ? performance.now() : Date.now();
        },
        setInitialActiveSection () {
            if (this.items.length > 0) {
                this.activeSection = this.items[0].id;
            }
        },
        scrollToSection (sectionId) {
            const target = document.getElementById(sectionId);
            const container = getScrollingElement(target);
            if (!target || !container) return;
            scrollToElement(target, {
                offset: this.scrollOffset,
                behavior: 'smooth'
            });
            if (!this.scrollingElement) this.scrollingElement = container;
            this.activeSection = sectionId;
            // Update hash after initiating scroll to avoid interrupting the animation
            requestAnimationFrame(()=>{
                const hash = `#${encodeURIComponent(sectionId)}`;
                window.history.pushState(null, '', hash);
            });
            // Prevent auto-tracking from overriding the clicked state during smooth scroll
            this.suppressAutoUpdateUntil = this.getCurrentTimestamp() + this.autoUpdateDelay;
        },
        isActive (itemId) {
            return this.activeSection === itemId;
        },
        initScrollTracking () {
            this.scrollingElement = resolveScrollContainer(this.items);
            if (!this.scrollingElement) return;
            this.onScroll = this.onScroll.bind(this);
            this.scrollingElement.addEventListener('scroll', this.onScroll, {
                passive: true
            });
            this.handleScroll();
        },
        onScroll () {
            if (this.scrollRafId) return;
            this.scrollRafId = requestAnimationFrame(()=>{
                this.scrollRafId = null;
                this.handleScroll();
            });
        },
        handleScroll () {
            const now = this.getCurrentTimestamp();
            if (now < this.suppressAutoUpdateUntil) return;
            if (!this.scrollingElement) return;
            const currentId = computeActiveSection(this.items, this.scrollingElement);
            if (currentId && currentId !== this.activeSection) {
                this.activeSection = currentId;
            }
        }
    }
};
